import { Col } from 'components/Col';
import { CustomTextArea } from 'components/CustomTextArea';
import { HelpButton } from 'components/HelpButton';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import { ChangeEvent, useContext, useMemo } from 'react';
import languageValues from 'utils/LanguageUtils';

const language = languageValues.inputs.descricaoIndiceFinal;
export default function ComoFoiIndiceFinal() {
  const { state, dispatch, validator } = useContext(ProjetosContext);

  const validation = useMemo(
    () =>
      validator?.getCampoIsValid({
        key: 'descricaoIndiceFinal',
        etapa: EtapaProjeto.indiceFinal,
        helperText: language?.required,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [validator, state.sent]
  );

  const label = useMemo(() => {
    return (
      <Col noPadding flex gap='8px' centralized>
        {language.label}
        {state.projeto.flgInfantil && <HelpButton text={language.tooltip} />}
      </Col>
    );
  }, [state.projeto.flgInfantil]);

  return (
    <Row>
      <Col>
        <CustomTextArea
          label={label}
          placeholder={language.placeholder}
          name='descricaoIndiceFinal'
          value={state.projeto.descricaoIndiceFinal || ''}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            dispatch({
              type: 'setProjeto',
              payload: { descricaoIndiceFinal: event.target.value },
            });
          }}
          counter={true}
          maxSize={8000}
          error={state.sent && validation?.error}
          helperText={
            state.sent && validation?.error ? validation?.helperText : undefined
          }
          minRows={1}
          disabled={state.disabledFields}
        />
      </Col>
    </Row>
  );
}
